import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { BookOutlined, DownOutlined, SettingOutlined } from "@ant-design/icons";
import { Button as ButtonAntd } from "antd";
import {
  LogOut,
  Layers,
  BuildingMultiple,
  Home,
  UserGroup,
  ViewGrid,
  MenuOutline,
  CloseOutline,
  FileEarmarkText,
  MailTemplate,
  FormNew,
} from "../../styles/Icons";

interface IResponsive {
  responsive?: boolean;
}

export const Container = styled.nav<IResponsive>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 7%;
  background-color: var(--black-opaco);

  .logout-mobile {
    display: none;
  }

  ${({ responsive }) =>
    responsive === true &&
    css`
      position: absolute;
      z-index: 1;

      .logout-mobile {
        position: fixed;
        top: 6.5%;
        right: 4%;
        display: unset;
        color: var(--white);
        z-index: 3;
      }
    `}
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 17%;
  width: 70%;

  img {
    width: 85%;
  }

  @media screen and (max-width: 575px) {
    height: 35%;

    img {
      width: 60%;
    }
  }
`;

export const NavMenuContainer = styled.ul`
  display: flex;
  flex-direction: column;
  height: 68%;
  width: 100%;
  margin-top: 5%;
  overflow-y: auto;
  @media screen and (max-width: 575px) {
    height: 65%;
    align-items: center;
    justify-content: center;
  }
`;

interface INavItem {
  actived?: boolean;
}

interface IMenuArrow {
  expanded: boolean;
}

export const MenuContainer = styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;

  width: 100%;
  height: 11%;
  padding: 3% 0;
  border-top: 1px solid var(--gray-900);
  transition: 0.2s;

  :last-child {
    border-bottom: 1px solid var(--gray-900);
  }

  @media screen and (max-width: 1600px) {
    height: 12%;
  }

  @media screen and (max-width: 1366px) {
    height: 15%;
  }

  @media screen and (max-width: 575px) {
    border-top: none;
    height: 10%;
    :last-child {
      border-bottom: none;
    }
  }
`;

export const NavItem = styled(Link)<INavItem>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 15%;
  width: 100%;
  height: 100%;
  font-size: 0.9rem;
  text-align: start;

  span {
    color: var(--gray-600);
  }

  :hover {
    span,
    svg {
      color: var(--white);
    }
  }

  ${({ actived }) =>
    actived &&
    css`
      border-radius: 0.9rem;
      background-color: var(--gray-800);

      span,
      svg {
        color: var(--white);
      }

      @media screen and (max-width: 575px) {
        background-color: transparent;
        &:before,
        &:after {
          content: "";
          flex: 1;
          height: 1px;
          margin: 0 1em;
          background: white !important;
          width: 100%;
        }
      }
    `}

  @media only screen and (max-width: 1680px) {
    padding: 0 15%;
  }

  @media only screen and (max-width: 1366px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 575px) {
    justify-content: center;
    font-size: 1rem;
    padding: 0;
    svg {
      display: none;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
  height: 15%;

  img {
    width: 3rem;
    height: 3rem;
    border-radius: 24px;
  }

  .perfil {
    color: var(--gray-600);
    font-size: 0.8rem;
  }

  @media only screen and (max-width: 1600px) {
    height: 17%;
  }

  @media only screen and (max-width: 1366px) {
    height: 21%;
  }

  @media only screen and (max-width: 575px) {
    display: none;
  }
`;

export const UserInfoContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 55%;
  padding: 3%;

  img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 24px;
  }

  .info-user-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .info-user {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-left: 1rem;

    .name-user {
      color: var(--white-25);
      font-size: 0.8rem;
    }

    .role-user {
      color: var(--gray-600);
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 575px) {
    display: none;
  }
`;

export const ButtonLogout = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45%;
  background-color: var(--gray-800);
  border-radius: 0.9rem;

  span,
  svg {
    color: var(--gray-50);
    font-size: 0.9rem;
  }
`;

const IconCSS = css`
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 1rem;
  color: var(--gray-600);

  @media only screen and (max-width: 1366px) {
    width: 1.1rem;
    height: 1.1rem;
  }
`;

export const LogOutIcon = styled(LogOut)`
  ${IconCSS}
  margin-right: 0.4rem;
  transform: rotate(180deg);
`;

export const ModuleIcon = styled(Layers)`
  ${IconCSS}
`;
export const CompaniesIcon = styled(BuildingMultiple)`
  ${IconCSS}
`;
export const HomeIcon = styled(Home)`
  ${IconCSS}
`;
export const UsersIcon = styled(UserGroup)`
  ${IconCSS}
`;
export const AccessIcon = styled(ViewGrid)`
  ${IconCSS}
`;

export const FileManagmenteIcon = styled(FileEarmarkText)`
  ${IconCSS}
`;

export const MailTemplateIcon = styled(MailTemplate)`
  ${IconCSS}
`;

export const FormNewIcon = styled(FormNew)`
  ${IconCSS}
`;

export const TwygoIcon = styled(BookOutlined)`
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
`;

export const StyledSettingIcon = styled(SettingOutlined)<{ isActive: boolean }>`
  font-size: 20px;
  color: ${({ isActive }) =>
    isActive ? "var(--orange-600)" : "var(--orange-250)"};
  cursor: pointer;
  transition: all 0.3s ease;
  transform: ${(props) => (props.isActive ? "rotate(90deg)" : "rotate(0deg)")};

  &:hover {
    color: var(--orange-600);
    transform: rotate(90deg);
  }
`;

export const MenuArrow = styled(DownOutlined)<IMenuArrow>`
  color: var(--gray-600);
  font-size: 12px;
  margin-left: auto;
  margin-right: 15px;
  transition: transform 0.3s ease;
  transform: ${({ expanded }) =>
    expanded ? "rotate(0deg)" : "rotate(-90deg)"};
`;

const ResponsiveIcon = css`
  display: none;
  @media only screen and (max-width: 575px) {
    position: fixed;
    top: 2.5%;
    left: 3%;
    display: unset;
    height: 1.5rem;
    width: 1.5rem;
    color: var(--gray-700);
    z-index: 1;
  }
`;

export const MenuIcon = styled(MenuOutline)`
  ${ResponsiveIcon}
`;

export const CloseIcon = styled(CloseOutline)`
  ${ResponsiveIcon}
  color: var(--white) !important;
  z-index: 3 !important;
`;

export const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
interface ISubMenuItem {
  actived?: boolean;
}

export const SubMenuItem = styled(Link)<ISubMenuItem>`
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  color: var(--gray-600);
  border-radius: 0.5rem;
  span {
    font-size: 0.85rem;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 0.5rem;
    color: var(--white);
  }

  ${({ actived }) =>
    actived &&
    css`
      background-color: var(--gray-800);
      color: var(--white);

      span {
        color: var(--white);
      }

      @media screen and (max-width: 575px) {
        background-color: transparent;
      }
    `}

  @media screen and (max-width: 575px) {
    padding: 0.5rem;
    justify-content: center;
  }
`;

export const ButtonModal = styled(ButtonAntd)`
  background-color: #1890ff;
  border: none;
  border-radius: 4px;
`;
